export default __webpack_public_path__ + "static/media/loading.328dbad4.png";